import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";
import { catchError, filter, map, of } from "rxjs";

@Component({
    selector: "gwo-not-authenticated-page",
    standalone: true,
    imports: [MatButton],
    templateUrl: "./not-authenticated-page.component.html",
    styleUrl: "./not-authenticated-page.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAuthenticatedPageComponent {
    private authService = inject(AuthService);
    private router = inject(Router);

    constructor() {
        this.checkAuthAndRedirect();
    }

    goToLogin(): void {
        this.authService.redirectToLogin();
    }

    private checkAuthAndRedirect() {
        if (!this.authService.isLoggedIn()) {
            this.authService.redirectToLogin();
            return;
        }

        this.authService
            .getUserInfo()
            .pipe(
                map((user) => {
                    if (!user?.name) {
                        throw new Error("Brak danych użytkownika");
                    }
                    return of(user);
                }),
                filter((user) => !!user),
                catchError(() => {
                    this.authService.redirectToLogin();
                    return of(null);
                }),
            )
            .subscribe(() => this.router.navigateByUrl("/"));
    }
}
